import React, { useState } from "react";
import { node, element, bool, string } from "prop-types";
import { Col, Container, Row } from "../Grid";
import NavbarToggleButton from "../Navbar/ToggleButton";
import { classes } from "../utils/classes";

const Header = ({ hero = false, isBorderBottomNone = false, className = "", logo, children }) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggle = () => setIsOpen(!isOpen);
	return (
		<header
			className={classes(
				"header",
				hero && "header--hero",
				isBorderBottomNone && "header--border-none",
				className,
			)}
			role="banner"
		>
			<Container>
				<Row px className="header__layout navbar">
					<Col>
						<Row middle justify>
							<div className="navbar__header align-justify">
								<div className="header__logo">{logo}</div>
								<NavbarToggleButton onClick={toggle} isOpen={isOpen} />
							</div>

							<div className={classes("navbar__collapse", isOpen && "show")} id="navbar">
								{children}
							</div>
						</Row>
					</Col>
				</Row>
			</Container>
		</header>
	);
};

Header.propTypes = {
	hero: bool,
	isBorderBottomNone: bool,
	// inverted: bool,
	logo: element.isRequired,
	children: node,
	className: string,
};

export default Header;
